import type { FunctionComponent } from 'react';

import { FormControl, type IFormikFormControlProps } from './FormControl'
import {
  DateOfBirthField,
  type DateOfBirthFieldProps,
} from '@ui/elements/DateOfBirthField'

export interface FormDateOfBirthFieldProps
  extends Omit<DateOfBirthFieldProps, 'name' | 'id' | 'helperText'>,
    IFormikFormControlProps {}

export const FormDateOfBirthField: FunctionComponent<
  FormDateOfBirthFieldProps
> = (props) => {
  const { id, name, disabled, ...formControlProps } = props
  const dateOfBirthFieldProps = { ...props, id, name }

  return (
    <FormControl id={id} name={name} disabled={disabled} {...formControlProps}>
      {({ value, handleChange, handleBlur, isSubmitting, error }) => (
        <DateOfBirthField
          {...dateOfBirthFieldProps}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          error={error}
          disabled={isSubmitting ?? disabled}
          required={formControlProps.required}
        />
      )}
    </FormControl>
  )
}
